import StoredLayout from '../../../../layouts/StoredLayout';
import ExpiryManagementForecasting from './ExpiryManagementForecasting';
export default StoredLayout(ExpiryManagementForecasting);
